import React, { useEffect, useState, useCallback } from "react";

// react redux
import { connect } from "react-redux";

// react router
import { Link } from "react-router-dom";

// styles
import {
	TopProductContainer,
	SectionTitle,
	SectionTitleSpan,
	ProductListContainer,
	ProductInfo,
	ProductLink,
	ProductDetail,
	ProductImageContainer,
	ProductImage,
	ProductPrice,
	ButtonContainer,
	Button,
} from "../../styles/TopProduct"

// products
import { getProducts, cancelGetProductsApi } from "utlis/Apis/Products_API";

// app messages
import {
	ERROR_WHILE__NAME,
	UNKNOWN_ERROR_OCCURED
} from "utlis/AppMessages/AppMessages";

// react toastify
import { toast } from "react-toastify";

// loading
import LoadingSkeleton from "./TopProduct__loadingSkeleton";

// no image found
import noImgFoundImg from 'assets/images/no-img.png'

function TopProduct(props) {
	// props
	const { commonToken } = props

	// consts
	const loadingIndicatorsCount = [1, 2, 3, 4, 5, 6]

	// states
	const [featuredProductsLoading, setFeaturedProductsLoading] = useState([]);
	const [featuredProducts, setFeaturedProducts] = useState([]);
	const [featuredProductsImages, setFeaturedProductsImages] = useState([]);

	const getFeaturedProducts = useCallback(() => {
		const URLParams = "is_featured=" + 1 + "&limit=9";
		// show loading
		setFeaturedProductsLoading(true)

		getProducts(commonToken ?? "", URLParams).then(res => {
			const resData = res.data;

			// hide loading
			setFeaturedProductsLoading(false)

			// if request succesfull
			if (resData?.success) {
				setFeaturedProducts(resData.data);
				// product images
				setFeaturedProductsImages(resData.images);
			}

			// if request is not succesfull
			if (resData?.error) {
				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(UNKNOWN_ERROR_OCCURED, {
					autoClose: 2500,
					onClose: () => { },
				});
			}
		}).catch(err => {
			console.log(`${ERROR_WHILE__NAME} getProducts `, err.message);

			// dismissing all the previous toasts first
			toast.dismiss();

			// showing the error message
			toast.error(UNKNOWN_ERROR_OCCURED, {
				autoClose: 2500,
				onClose: () => {
					// hide loading
					setFeaturedProductsLoading(false)
				},
			});
		})
	}, [commonToken])

	// useEffect(() => {
	// 	// getting products
	// 	getFeaturedProducts()
	// 	return () => {
	// 		cancelGetProductsApi && cancelGetProductsApi()
	// 	}
	// }, [getFeaturedProducts])

	useEffect(() => {
		const URLParams = "is_featured=" + 1 + "&limit=9";

		getProducts(commonToken ?? "", URLParams).then(res => {
			const resData = res.data;

			// hide loading
			setFeaturedProductsLoading(false)

			// if request succesfull
			if (resData?.success) {
				setFeaturedProducts(resData.data);
				// product images
				setFeaturedProductsImages(resData.images);
			}

			// if request is not succesfull
			if (resData?.error) {
				// dismissing all the previous toasts first
				toast.dismiss();

				// showing the error message
				toast.error(UNKNOWN_ERROR_OCCURED, {
					autoClose: 2500,
					onClose: () => { },
				});
			}
		}).catch(err => {
			console.log(`${ERROR_WHILE__NAME} getProducts `, err.message);

			// dismissing all the previous toasts first
			toast.dismiss();

			// showing the error message
			toast.error(UNKNOWN_ERROR_OCCURED, {
				autoClose: 2500,
				onClose: () => {
					// hide loading
					setFeaturedProductsLoading(false)
				},
			});
		})

		return () => {
			cancelGetProductsApi && cancelGetProductsApi()
		}
	}, [])

	return (
		<TopProductContainer>
			<div className="container">
				<SectionTitle>
					<SectionTitleSpan>
						FUNCTION MEETS STYLE HERE
					</SectionTitleSpan>
					our favorite picks
				</SectionTitle>

				<ProductListContainer>
					<div className="row">
						{
							featuredProductsLoading ? (
								<div className="loading-container row">
									{
										(loadingIndicatorsCount?.length) ? loadingIndicatorsCount.map(item => (
											<React.Fragment key={item}>
												<LoadingSkeleton />
											</React.Fragment>
										)) : null
									}
								</div>
							) : (
								<React.Fragment>
									{
										featuredProducts?.length ? featuredProducts.map(o => {
											return (
												<div className="col-sm-6 col-md-6 col-lg-4" key={o.product_id}>
													<ProductInfo>
														<ProductLink>
															<ProductImageContainer>
																<Link to={`/product/${o.product_url}?id=${o.product_id}`} className="text-decoration-none d-block img-container-inner">
																	<ProductImage
																		src={featuredProductsImages[o.product_id]?.main_thumb?.small || noImgFoundImg}
																		onLoad={ev => ev.target.parentNode.classList.add("loaded")}
																	/>
																</Link>
																<Link to={`/product/${o.product_url}?id=${o.product_id}`} className="text-decoration-none d-block text-black">
																	<ProductDetail>{o.product_name}</ProductDetail>
																</Link>

																<ProductPrice>
																	${o.price.toFixed(2)}
																</ProductPrice>

																<ButtonContainer>
																	<Link to={`/product/${o.product_url}?id=${o.product_id}`} className="text-decoration-none">
																		<Button>Buy Now</Button>
																	</Link>
																</ButtonContainer>
															</ProductImageContainer>
														</ProductLink>
													</ProductInfo>
												</div>
											);
										}) : (
											<React.Fragment>
												<div className="text-center py-2">
													No product found
												</div>
											</React.Fragment>
										)
									}
								</React.Fragment>
							)
						}
					</div>
				</ProductListContainer>
			</div>
		</TopProductContainer>
	);
}

const getDataFromStore = (state) => {
	return {
		commonToken: state.auth.commonToken,
	};
};

export default connect(getDataFromStore, null)(TopProduct);